import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import BlogManagement from '../../../components/siteadmin/Blog/BlogManagement';

// Query
import getBlogDetails from './getBlogDetails.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from './BlogManagement.css';

function BlogManagements(props) {

    const { data: { getBlogDetails, loading, refetch }, title } = props;

    const [stateVariable, setStateVariable] = useState({
        currentPage: 1,
        searchList: ''
    });

    return (
        <BlogManagement
            data={getBlogDetails}
            title={title}
            loading={loading}
            refetch={refetch}
            currentPage={stateVariable?.currentPage}
            searchList={stateVariable?.searchList}
            setStateVariable={setStateVariable}
        />
    );
}

BlogManagements.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
        loading: PropTypes.bool,
        getBlogDetails: PropTypes.array,
    })
};

BlogManagements.defaultProps = {
    data: {
        loading: true
    }
};

export default compose(
    withStyles(s),
    withQuery(getBlogDetails,
        {
            options: {
                fetchPolicy: 'network-only',
                ssr: false
            }
        }),
)(BlogManagements);